import '../styles/ArticleDetailPage.css';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchArticleDetail } from '../services/api';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

interface Article {
  id: number;
  title: string;
  author: string;
  date: string;
  summary: string;
  content: string; // Added content to the interface
}

const ArticleDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [article, setArticle] = useState<Article | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const likeCount = Math.floor(20 + Math.random() * 80);
  const commentCount = Math.floor(5 + Math.random() * 30);

  useEffect(() => {
    const getDetail = async () => {
      try {
        const data = await fetchArticleDetail(Number(id));
        setArticle(data);
      } catch (e) {
        setError('未找到该文章');
      } finally {
        setLoading(false);
      }
    };
    getDetail();
  }, [id]);

  if (loading) return (
    <main style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 64px)',
      marginTop: '64px'
    }}>
      <div style={{ textAlign: 'center', color: '#666', fontSize: '16px' }}>
        正在加载文章详情...
      </div>
    </main>
  );
  if (error) return (
    <main style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 64px)',
      marginTop: '64px'
    }}>
      <div style={{ textAlign: 'center', color: '#c33', fontSize: '16px' }}>
        <div style={{ marginBottom: '20px' }}>😕 {error}</div>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            background: '#1a8917',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          重新加载
        </button>
      </div>
    </main>
  );
  if (!article) return (
    <main style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 64px)',
      marginTop: '64px'
    }}>
      <div style={{ textAlign: 'center', color: '#666', fontSize: '16px' }}>
        未找到该文章
      </div>
    </main>
  );

  return (
    <div className="article-detail">
      <h1 className="detail-title">{article.title}</h1>
      <div className="detail-meta-row">
        <span className="detail-author">{article.author}</span>
        <button className="detail-follow-btn">关注</button>
        <span className="detail-date">{dayjs(article.date).format('YYYY年M月D日')}</span>
      </div>
      <hr className="detail-divider" />
      <div className="detail-action-row">
        <span className="detail-like" style={{ display: 'flex', alignItems: 'center' }}>
          <svg width="16" height="16" viewBox="0 0 16 16" style={{ marginRight: 4 }}>
            <defs>
              <linearGradient id="like-gradient" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#ff7e5f" />
                <stop offset="100%" stopColor="#feb47b" />
              </linearGradient>
            </defs>
            <path d="M8 14s-5-3.33-5-7.5A3.5 3.5 0 0 1 8 3a3.5 3.5 0 0 1 5 3.5C13 10.67 8 14 8 14z" fill="url(#like-gradient)" stroke="#ff7e5f" strokeWidth="1" />
          </svg>
          {likeCount}
        </span>
        <span className="detail-comment" style={{ display: 'flex', alignItems: 'center' }}>
          <svg width="16" height="16" viewBox="0 0 16 16" style={{ marginRight: 4 }}>
            <defs>
              <linearGradient id="comment-gradient" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#43cea2" />
                <stop offset="100%" stopColor="#185a9d" />
              </linearGradient>
            </defs>
            <path d="M2 2h12v9H5.414L2 14V2z" fill="url(#comment-gradient)" stroke="#185a9d" strokeWidth="1" />
          </svg>
          {commentCount}
        </span>
        <span className="detail-share" style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M3 10l13-6-6 13-1.5-5.5L3 10z" stroke="#bbb" strokeWidth="1.5" fill="none" />
          </svg>
        </span>
      </div>
      <hr className="detail-divider" />
      <div className="detail-content" dangerouslySetInnerHTML={{ __html: article.content || '' }} />
    </div>
  );
};

export default ArticleDetailPage; 